import axios from "config/@axios";
import * as savedSearchActions from "./savedSearchActions";

export const FETCH_SAVED_SEARCHES = "savedSearchesActions::fetchSavedSearches";
export const FETCH_SAVED_SEARCHES_SUCCESS =
  "savedSearchesActions::fetchSavedSearchesSuccess";
export const FETCH_SAVED_SEARCHES_FAILED =
  "savedSearchesActions::fetchSavedSearchesFailed";
export const DELETE_ITEM = "savedSearchesActions::deleteItem";

export const fetchByPage =
  ({ page, data = {} }) =>
  (dispatch, getState) => {
    const state = getState();
    const perPage = state.auth.settings.display_mail_count;
    let offset;
    if (page < 1) {
      offset = 0;
    } else {
      offset = (page - 1) * perPage;
    }

    dispatch(savedSearchActions.setPage(page));
    return dispatch(
      fetchSavedSearches({ ...data, count: perPage, start: offset })
    );
  };

export const fetchSavedSearches =
  (params = null) =>
  (dispatch, getState) => {
    const state = getState();
    const searchParams = state.savedArchiveSearch.searchParams;

    const currentParams = {
      ...searchParams,
      ...params
    };

    dispatch({
      type: FETCH_SAVED_SEARCHES
    });

    return axios
      .get("archives/savedsearches", { params: currentParams })
      .then(response => {
        const totalCount = parseInt(response.headers["x-total-count"]);
        dispatch(savedSearchActions.setTotal(totalCount));
        dispatch({
          type: FETCH_SAVED_SEARCHES_SUCCESS,
          payload: {
            savedSearches: response.data
          }
        });
        dispatch(savedSearchActions.setSearchParams(currentParams));
      })
      .catch(err => {
        dispatch({
          type: FETCH_SAVED_SEARCHES_FAILED,
          payload: {
            errorText: err.errorMessage
          }
        });
      });
  };

export const deleteItem = id => ({
  type: DELETE_ITEM,
  payload: {
    id
  }
});
